import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export function MegaHeartAdmin() {
  const [m, setM] = useState(null);
  const [t, setT] = useState("");
  useEffect(() => { api.get("/megaheart").then(({ data }) => { setM(data); setT(data.reward); }).catch(() => {}); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/admin/megaheart", { reward: t }); setM(data); toast.success("Belohnung gespeichert 💖"); } catch (err) { toast.error(formatErr(err)); }
  };
  if (!m) return null;
  return (
    <div className="max-w-2xl space-y-4" data-testid="megaheart-admin">
      <div className="mega-heart relative overflow-hidden rounded-3xl p-5 text-white">
        <p className="relative font-extrabold flex items-center gap-2"><Heart className="w-5 h-5" fill="currentColor" /> Diese Woche ({m.week})</p>
        <p className="relative text-sm mt-1" data-testid="megaheart-admin-status">{m.taps} / {m.goal} Herzschläge · {m.tappers} Mitglieder dabei · {m.done ? "Ziel geschafft 🎉" : "läuft"}</p>
      </div>
      <form onSubmit={save} className="bg-white rounded-3xl border border-pink-100 p-5 space-y-3">
        <label className="block text-sm font-bold" htmlFor="mh-reward">Belohnung, wenn die Community das Ziel schafft</label>
        <input id="mh-reward" value={t} maxLength={140} onChange={(e) => setT(e.target.value)} data-testid="megaheart-admin-reward" placeholder="z. B. Wir drehen euer Wunsch-Video 🎬"
          className="w-full h-11 px-4 rounded-full border border-pink-100 text-sm focus:outline-none focus:ring-2 focus:ring-rose-200" />
        <p className="text-xs text-slate-500">Gilt sofort für diese Woche und bleibt für die nächsten Wochen, bis du sie änderst. Das Ziel wächst automatisch mit der Zahl der Mitglieder.</p>
        <button disabled={t.trim().length < 2} data-testid="megaheart-admin-save" className="h-11 px-6 rounded-full pink-gradient text-white text-sm font-bold disabled:opacity-50">Speichern</button>
      </form>
    </div>
  );
}
